// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package24: FC<Package24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M11 19.425v-6.85L5 9.1v6.85l6 3.475Zm2 0 6-3.475V9.1l-6 3.475v6.85Zm-2 2.3L4 17.7a1.948 1.948 0 0 1-1-1.725v-7.95A1.948 1.948 0 0 1 4 6.3l7-4.025c.317-.183.65-.275 1-.275s.683.092 1 .275L20 6.3a1.948 1.948 0 0 1 1 1.725v7.95a1.948 1.948 0 0 1-1 1.725l-7 4.025c-.317.183-.65.275-1 .275s-.683-.092-1-.275Zm5-13.2 1.925-1.1L12 4l-1.95 1.125 5.95 3.4Zm-4 2.325 1.95-1.125L8.025 6.3l-1.95 1.125L12 10.85Z" />
        </svg>
    );
};

export default Package24;
